/* eslint-disable import/prefer-default-export */
import * as Sentry from "@sentry/react";

/**
 * Get the current Sentry client. If there are no existing client, initialize a new one.
 * This function makes sure that the Sentry client is initialized only once and the same Sentry client
 * is used for both logging and tracing.
 * @param dsn The Data Source Name (DSN) for Sentry
 * @returns The Sentry client instance
 */
export const getSentryClient = (
  dsn?: string,
  environment?: string,
): ReturnType<typeof Sentry.getClient> => {
  let client = Sentry.getClient();
  client ??= Sentry.init({
    dsn,
    defaultIntegrations: false,
    environment,
  });
  return client;
};
